module.exports = __webpack_public_path__ + "img/product-right.b6659bba.png";